import React, { useEffect } from 'react';
import '../styles/Industries.css';
import Footer from '../components/Footer';

const Industries = () => {
  useEffect(() => {
    // Initialize animations
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -100px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
        }
      });
    }, observerOptions);

    // Observe all elements with data-aos attribute
    const animatedElements = document.querySelectorAll('[data-aos]');
    animatedElements.forEach(el => {
      el.style.opacity = '0';
      el.style.transform = 'translateY(30px)';
      el.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
      observer.observe(el);
    });

    return () => {
      observer.disconnect();
    };
  }, []);

  const industries = [
    {
      id: 1,
      title: 'Film Making',
      image: '/assets/img/Industry/film-making.jpg',
      alt: 'Film Making',
      description: 'From concept to final cut, we bring cinematic excellence to every project, creating compelling narratives that captivate audiences and drive results.',
      delay: '100'
    },
    {
      id: 2,
      title: 'Event Management',
      image: '/assets/img/Industry/event-management.jpg',
      alt: 'Event Management',
      description: 'Comprehensive event management services covering corporate events, conferences, product launches, and special occasions with professional coordination and execution.',
      delay: '200'
    },
    {
      id: 5,
      title: 'Corporate Videos',
      image: '/assets/img/Industry/corporate-videos.jpg',
      alt: 'Corporate Videos',
      description: 'Professional corporate video production for training, presentations, marketing, and internal communications that effectively convey your message.',
      delay: '500'
    },
    {
      id: 6,
      title: 'Documentary Films',
      image: '/assets/img/Industry/documentary.webp',
      alt: 'Documentary Films',
      description: 'Compelling documentary filmmaking that explores real stories, educates audiences, and creates meaningful impact through authentic storytelling.',
      delay: '600'
    },
    {
      id: 7,
      title: 'Music Videos',
      image: '/assets/img/Industry/music-videos.jpg',
      alt: 'Music Videos',
      description: 'Creative music video production that brings songs to life with innovative visuals, artistic direction, and engaging storytelling.',
      delay: '700'
    },
    {
      id: 8,
      title: 'Commercial Ads',
      image: '/assets/img/Industry/commercial-ads.jpg',
      alt: 'Commercial Ads',
      description: 'High-impact commercial advertising that drives brand awareness, engages target audiences, and delivers measurable results for businesses.',
      delay: '800'
    },
    {
      id: 9,
      title: 'Short Films',
      image: '/assets/img/Industry/short-films.jpg',
      alt: 'Short Films',
      description: 'Creative short film production that showcases artistic vision, tells compelling stories, and demonstrates cinematic excellence in compact formats.',
      delay: '900'
    },
    {
      id: 10,
      title: 'Brand Films',
      image: '/assets/img/Industry/brand-films.jpg',
      alt: 'Brand Films',
      description: 'Strategic brand film production that builds emotional connections, communicates brand values, and strengthens customer relationships.',
      delay: '1000'
    }
  ];

  return (
    <div className="industries-page" style={{backgroundColor: '#f8f9fa', minHeight: '100vh', padding: '20px'}}>
      {/* Industries Section */}
      <section className="industries-section" style={{padding: '100px 0', backgroundColor: '#f8f9fa'}}>
        <div className="industries-container" style={{maxWidth: '1200px', margin: '0 auto', padding: '0 20px'}}>
          <div className="industries-header" data-aos="fade-up" style={{textAlign: 'center', marginBottom: '60px'}}>
            <h2 className="industries-title" style={{fontSize: '3rem', fontWeight: '800', color: '#2c3e50', marginBottom: '20px'}}>Our Industry Expertise</h2>
            <span className="industries-underline" style={{display: 'block', width: '150px', height: '5px', background: 'linear-gradient(90deg, #667eea 0%, #764ba2 100%)', margin: '0 auto 30px', borderRadius: '3px'}}></span>
            <p className="industries-description" style={{fontSize: '1.2rem', color: '#555', maxWidth: '800px', margin: '0 auto', lineHeight: '1.8'}}>
              We are renowned experts, producing standard and reliable ad film production services for different industries. Our ad film-making creates brand awareness by grabbing the audience's attention. Our ad films portray the highlights of your business objectives and build an emotional connection with your brand. We also endorse the appropriate celebrity that perfectly suits the brand and engages the audiences.
            </p>
          </div>

          <div className="industries-grid" style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))', gap: '30px', marginTop: '2rem'}}>
            {industries.map((industry) => (
              <div 
                key={industry.id} 
                className="industry-card" 
                data-aos="fade-up" 
                data-aos-delay={industry.delay}
                style={{
                  background: 'rgba(255, 255, 255, 0.9)',
                  borderRadius: '20px',
                  padding: '30px',
                  textAlign: 'center',
                  boxShadow: '0 10px 30px rgba(0, 0, 0, 0.1)',
                  transition: 'all 0.4s ease',
                  border: '2px solid transparent'
                }}
              >
                <img 
                  src={industry.image} 
                  alt={industry.alt} 
                  className="industry-image" 
                  style={{
                    width: '100%',
                    height: '200px',
                    objectFit: 'cover',
                    borderRadius: '15px',
                    marginBottom: '25px'
                  }}
                />
                <h3 className="industry-title" style={{fontSize: '1.5rem', fontWeight: '700', color: '#2c3e50', marginBottom: '15px'}}>{industry.title}</h3>
                <p className="industry-description" style={{fontSize: '1rem', color: '#6c757d', lineHeight: '1.6', margin: '0'}}>{industry.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Industries;
